import { useMemo } from 'react';

import { getReadStates } from '../utils';

import type { UserResponse } from 'belo-js-sdk';

import type { StreamMessage } from '../../../context/ChannelStateContext';

import type { DefaultBeloChatGenerics } from '../../../types/types';

type UseLastReadDataParams<
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
> = {
  messages: StreamMessage<BeloChatGenerics>[];
  returnAllReadData: boolean;
  userID: string | undefined;
  read?: Record<string, { last_read: Date; user: UserResponse<BeloChatGenerics> }>;
};

export const useLastReadData = <
  BeloChatGenerics extends DefaultBeloChatGenerics = DefaultBeloChatGenerics
>(
  props: UseLastReadDataParams<BeloChatGenerics>,
) => {
  const { messages, read, returnAllReadData, userID } = props;

  return useMemo(
    () =>
      getReadStates(
        messages.filter(({ user }) => user?.id === userID),
        read,
        returnAllReadData,
      ),
    [messages, read, returnAllReadData, userID],
  );
};
